import styled from 'styled-components';
import { Colors } from '~/constants';

const ErrorMessage = styled.p`
  color: ${Colors.RED};
  padding-top: 10px;
`;

export default ErrorMessage;
